module.exports = __webpack_public_path__ + "static/exp7e-24d671ea5f87c48f10134d909815fd45.png";